import { ChannelKindSchema } from '@wit-support/contracts';
/**
 * Maps every ChannelKind to a Radix hue. Contract test
 * (`channels.test.ts`) enforces exhaustiveness against
 * `ChannelKindSchema.options` at runtime; the `Record` type
 * enforces it at compile time.
 */
export const CHANNEL_HUE = {
    gmail: 'red',
    web_form: 'slate',
    imap: 'violet',
    smtp_inbound: 'cyan',
};
// Re-export the enum values as a readable constant for consumers.
export const CHANNEL_KINDS = ChannelKindSchema.options;
//# sourceMappingURL=channels.js.map